import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { YEAR } from '../../utils/ConstantsMain';
import { isMobile } from 'react-device-detect';
import {
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
  TextField,
  Grid,
  Tooltip,
  ClickAwayListener,
  Button,
} from '@material-ui/core';
import "./addHolders.scss";

const styles = () => ({
  buttonImage: {
    border: 'none',
    '&:hover': {
      backgroundColor: '#e7e7e7',
    }
  },
  inputFile: {
    height: 96,
    display: 'none',
  },
  photos: {
    objectFit: 'cover',
  },
  form: {
    position: 'relative',
    margin: '0 0 73px 0'
  },
  borderDiv: {
    position: 'absolute',
    width: '95%',
    height: '116%',
    border: '1px solid #e7e7e7',
    margin: '-16px 0 0 -16px',
  },
  select: {
    borderRadius: 2,
    border: '1px solid rgb(150,150,150)',
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.87)',
    },
  },
  selectRoot: {
    height: 74,
    overflow: 'auto',
    whiteSpace: 'normal',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  selectMenu: {
    padding: '10px 14px',
    fontSize: 16,
    lineHeight: 1,
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 22,
    bottom: 0,
  },
  expandButton: {
    display: 'flex',
    color: '#013957',
    cursor: 'pointer',
  },
  heightSelect: {
    
    maxWidth: 256,
    margin: '0 24px 0 0',
    height: 76,
  },
  nameUniversity: {
    height: 76,
    margin: 0,
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    zIndex: 10,
    right: 'unset',
    backgroundColor: '#fff',
    height: 'fit-content',
  },
  listItemText: {
    fontSize: 14,
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  inputError: {
    border: '1px solid #d74242',
    '&:hover': {
      border: '1px solid #d74242',
    },
  },
  TextField: {
    maxWidth: '536px',
    margin: '0 0 6px 0',
    width: '100%',
    "&:$last-child": {
      margin: '20px 0 6px 0'
    },
    '@media screen and (max-width: 500px)': {
      maxWidth: '100%',
      width: '100%'
    },
  },
  TextField_small: {
    maxWidth: '144px',
    marginRight: '24px',
  },
  Grid: {
    paddingLeft: '8px',
  },
  input_icon: { 
    maxWidth: '560px'
  },
  input_iconCedula: {
    maxWidth: '544px',
    paddingRight: 8,
    minWidth: '75%',
  },
  input_iconArea: { 
    maxWidth: '544px',
    paddingRight: 8,
    minWidth: '75%',
    margin: '0 0 -28px 0',
  },
  areaContainer: {
    margin: '0 0 30px 0',
  },
  rootFormControl :{
    display : 'flex',
    alignItems: 'center',
  },
  customTooltip: {
    backgroundColor: '#094565',
    margin: '10px 8px 0',
    padding: 8,
    maxWidth: 232,
    lineHeight: 1.2,
  },
  tooltipParagraph: {
    margin: 0,
    fontSize: 14,
    '& b': {
      fontSize: 14,
      fontWeight: 'bold',
    },
  },
  tooltipImage: {
    margin: '28px 0 0',
  },
  secondGrid: {
    display: 'flex',
    zIndex: 1,
  },
  deleteAction: {
    color: '#d74242',
    fontSize: 12,
    margin: '24px 0 0',
    textTransform: 'capitalize',
    height: 'fit-content',
    '@media screen and (max-width: 768.98px)': {
      position: 'absolute',
      bottom: '-10px',
      right: 20,
    },
  },
  '@media screen and (max-width: 769px) and (max-width: 1110px)': {
    borderDiv: {
      width: '105%',
    },
  },
  '@media screen and (min-width: 448px) and (max-width: 768.98px)': {
    heightSelect: {
      width: '47%',
    }
  },
  '@media screen and (min-width: 400px) and (max-width: 447.98px)': {
    heightSelect: {
      width: '46%',
    }
  },
  '@media screen and (max-width: 399.98px)': {
    borderDiv: {
      width: '105%',
    },
    nameUniversity: {
      width: '90%',
    },
    TextField: {
      width: '90%',
    },
    heightSelect: {
      maxWidth: 'initial',
      width: '90%',
    }
  },
  '@media screen and (min-width: 983px) and (max-width: 1179.98px)': {
    input_iconArea: { 
      maxWidth: '92%',
      minWidth: '92%',
    },
    input_iconCedula: {
      maxWidth: '92%',
      minWidth: '92%',
    },
  },
  '@media screen and (min-width: 769px) and (max-width: 982.98px)': {
    input_iconArea: { 
      maxWidth: '92%',
      minWidth: '92%',
    },
    input_iconCedula: {
      maxWidth: '92%',
      minWidth: '92%',
    },
  },
  '@media screen and (max-width: 768.98px)': {
    input_iconArea: {
      width: '92%',
      margin: '0 0 22px 0',
      minWidth: '77%'
    },
    input_iconCedula: { 
      flexGrow: 0,
      minWidth: '80%',
      width: '92%',
      '& div': {
        width: '100%',
      }
    },
    areaContainer: {
      margin: '0 0 -25px 0',
    },
  },
  '@media screen and (max-width: 400px)': {
    input_iconCedula: { 
      flexGrow: 0,
      minWidth: '90%',
      margin: '0 3px 0 0',
      padding: 0,
      width: '92%',
      '& div': {
        width: '100%',
      }
    },
  }
});

const HolderPublicationsForm = props => {

  const {
    publications,
    publicationsHelper,
    handleChange,
    handleBlur,  
    touched,
    errors,
    classes,
    index,
  } = props;

  const [openTitle, setOpenTitle] = useState(false);

  const handleTooltipCloseTitle = () => {
    setOpenTitle(false);
  };

  const handleTooltipOpenTitle = () => {
    setOpenTitle(true);
  };

  const deleteSubForm = () => {    
    publicationsHelper.remove(index)
  };

  return (
    <form className={classes.form}>
      <div className={classes.borderDiv}></div>

      <Grid item xs container direction="row">
        <Grid item xs classes={{ root: classes.input_iconCedula }}>
          <TextField
            label="Título de la publicación"
            name={`publications[${index}].title`}
            id="publicationName"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={publications && publications.title ? publications.title : ''}
            helperText={
              touched &&
              touched.publications &&
              touched.publications[index] &&
              touched.publications[index].title &&
              errors &&
              errors.publications &&
              errors.publications[index] &&
              errors.publications[index].title ?
              errors.publications[index].title :
              ''
            }
            error={
              touched &&
              touched.publications &&
              touched.publications[index] &&
              touched.publications[index].title &&
              errors &&
              errors.publications &&
              errors.publications[index] &&
              errors.publications[index].title ?
              true : false
            }
            fullWidth
            classes={{ root: classes.TextField }}
          />
        </Grid>
        <Grid item className={classes.secondGrid}>
          <div>
            {isMobile === true ?
              <ClickAwayListener onClickAway={handleTooltipCloseTitle}>
                <Tooltip
                  onClose={handleTooltipCloseTitle}
                  open={openTitle}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  classes={{tooltip: classes.customTooltip}}
                  title={
                    <p className={classes.tooltipParagraph}>
                      El campo "título de la publicación" <b>no es obligatorio</b> pero recomendamos llenarlo.
                    </p>
                  }
                  placement='left'
                  >
                    <img 
                      src="../../img/profile/ayuda.png"
                      alt="?"
                      onClick={handleTooltipOpenTitle}
                      className={classes.tooltipImage}
                    />
                </Tooltip>
              </ClickAwayListener> :
              <Tooltip
                classes={{tooltip: classes.customTooltip}}
                title={
                  <p className={classes.tooltipParagraph}>
                    El campo "título de la publicación" <b>no es obligatorio</b> pero recomendamos llenarlo.
                  </p>
                }
                placement='bottom'
              >
                <img
                  src="../../img/profile/ayuda.png"
                  alt="?"
                  className={classes.tooltipImage}
                />
              </Tooltip>
            }
          </div>

          {index && index !== 0 ?
            <Button
              key={index}
              component="span"
              type="button"
              onClick={deleteSubForm}
              className={classes.deleteAction}
            >
              Eliminar
            </Button> : null
          }
        </Grid>
      </Grid>

      <TextField
        name={`publications[${index}].url`}
        label="URL de la publicación"
        id="url"
        type="text"
        variant="outlined"
        onBlur={handleBlur}
        onChange={handleChange}
        value={publications && publications.url ? publications.url : ''}
        helperText={
          touched &&
          touched.publications &&
          touched.publications[index] &&
          touched.publications[index].url &&
          errors &&
          errors.publications &&
          errors.publications[index] &&
          errors.publications[index].url ?
          errors.publications[index].url :
          ''
        }
        error={
          touched &&
          touched.publications &&
          touched.publications[index] &&
          touched.publications[index].url &&
          errors &&
          errors.publications &&
          errors.publications[index] &&
          errors.publications[index].url ?
          true : false
        }
        fullWidth
        className={classes.TextField}
      />

      <FormControl
        classes={{ root: classes.heightSelect }}
        variant="outlined"
        error={touched.Items && errors.Items ? true : false}
      >
        <InputLabel
          htmlFor="select-multiple-checkbox"
          classes={{
            root: classes.inputLabelRoot,
            shrink: classes.inputLabelShrink,
          }}
        >
          {'Año de la publicación'}
        </InputLabel> 
          <Select
            id='year'
            name={`publications[${index}].year`}
            value={publications && publications.year ? publications.year : []}
            onChange={handleChange}
          >
            {YEAR && YEAR.map((item, index) => (
              <MenuItem key={index} value={item.value} >
                {item.name}
              </MenuItem>
            ))}
        </Select>
        {touched &&
        touched.publications &&
        touched.publications[index] &&
        touched.publications[index].year &&
        errors &&
        errors.publications &&
        errors.publications[index].year ? (
          <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
            {errors.publications[index].year}
          </FormHelperText>
        ) : (
          ''
        )}
      </FormControl>
      
    </form>
  )
};

export default withStyles(styles)(HolderPublicationsForm);
